module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-page"
  }, [_c('home-header'), _vm._v(" "), _c('main', {
    staticClass: "site-body"
  }, [_c('main', {
    staticClass: "home-page"
  }, [_c('section', {
    staticClass: "experience-use-free clearfix"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "easy-use-content clearfix"
  }, [_c('div', {
    staticClass: "easy-use-register-mobile"
  }, [_vm._m(1), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入企业名称、核心人员姓名等关键词。"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search pl-2 pr-4",
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  })]), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])])]), _vm._v(" "), _c('section', {
    staticClass: "application-introduce clearfix mobile-hidden"
  }, [_c('div', {
    staticClass: "wrapper",
    staticStyle: {
      "margin-top": "-60px",
      "background-color": "white",
      "padding": "10px",
      "border-radius": "3px"
    }
  }, [_c('ul', {
    staticClass: "navList"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.go_to_panel('insight')
      }
    }
  }, [_vm._m(6), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.go_to_panel('user/export')
      }
    }
  }, [_vm._m(8), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.dialogAds = true
      }
    }
  }, [_vm._m(10), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _c('li', {
    staticClass: "feedback",
    on: {
      "click": function($event) {
        _vm.dialogCooperation = true
      }
    }
  }, [_vm._m(12), _vm._v(" "), _vm._m(13)])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "bg-white",
    staticStyle: {
      "min-height": "520px",
      "border": "1px solid #e5ecfc",
      "border-right": "0px"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": "area",
      "collapse": false
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "area"
    },
    on: {
      "click": function($event) {
        return _vm.go_to_panel('area')
      }
    }
  }, [_vm._v("按地区找客户")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "indus"
    },
    on: {
      "click": function($event) {
        return _vm.go_to_panel('indus')
      }
    }
  }, [_vm._v("按行业找客户")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "chain"
    },
    on: {
      "click": function($event) {
        return _vm.go_to_panel('chain')
      }
    }
  }, [_vm._v("按产业链")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "tags"
    },
    on: {
      "click": function($event) {
        return _vm.go_to_panel('tags')
      }
    }
  }, [_vm._v("按企业标签")])], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "scrollable-div",
    staticStyle: {
      "min-height": "520px",
      "border": "1px solid #e5ecfc"
    }
  }, [_c('div', {
    staticClass: "bg-white"
  }, [(_vm.panel == 'indus') ? _c('div', {
    staticClass: "content-box p-3 pt-0"
  }, [_c('div', {
    staticClass: "panel-list-right"
  }, [_c('div', {
    staticClass: "panel-list"
  }, [_c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=A"
    }
  }, [_vm._v("农、林、牧、渔业")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=A,01"
    }
  }, [_vm._v("农业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=A,02"
    }
  }, [_vm._v("林业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=A,03"
    }
  }, [_vm._v("畜牧业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=A,04"
    }
  }, [_vm._v("渔业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=A,05"
    }
  }, [_vm._v("农、林、牧、渔专业及辅助性活动")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=B"
    }
  }, [_vm._v("采矿业")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=B,06"
    }
  }, [_vm._v("煤炭开采和洗选业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=B,07"
    }
  }, [_vm._v("石油和天然气开采业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=B,08"
    }
  }, [_vm._v("黑色金属矿采选业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=B,09"
    }
  }, [_vm._v("有色金属矿采选业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=B,10"
    }
  }, [_vm._v("非金属矿采选业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=B,11"
    }
  }, [_vm._v("开采专业及辅助性活动")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=B,12"
    }
  }, [_vm._v("其他采矿业")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C"
    }
  }, [_vm._v("制造业")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,13"
    }
  }, [_vm._v("农副食品加工业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,14"
    }
  }, [_vm._v("食品制造业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,15"
    }
  }, [_vm._v("酒、饮料和精制茶制造业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,16"
    }
  }, [_vm._v("烟草制品业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,17"
    }
  }, [_vm._v("纺织业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,18"
    }
  }, [_vm._v("纺织服装、服饰业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,19"
    }
  }, [_vm._v("皮革、毛皮、羽毛及其制品和制鞋业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,20"
    }
  }, [_vm._v("木材加工和木、竹、藤、棕、草制品业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,21"
    }
  }, [_vm._v("家具制造业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,22"
    }
  }, [_vm._v("造纸和纸制品业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,23"
    }
  }, [_vm._v("印刷和记录媒介复制业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,24"
    }
  }, [_vm._v("文教、工美、体育和娱乐用品制造业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,25"
    }
  }, [_vm._v("石油、煤炭及其他燃料加工业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,26"
    }
  }, [_vm._v("化学原料和化学制品制造业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,27"
    }
  }, [_vm._v("医药制造业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,28"
    }
  }, [_vm._v("化学纤维制造业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,29"
    }
  }, [_vm._v("橡胶和塑料制品业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,30"
    }
  }, [_vm._v("非金属矿物制品业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,31"
    }
  }, [_vm._v("黑色金属冶炼和压延加工业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,32"
    }
  }, [_vm._v("有色金属冶炼和压延加工业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,33"
    }
  }, [_vm._v("金属制品业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,34"
    }
  }, [_vm._v("通用设备制造业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,35"
    }
  }, [_vm._v("专用设备制造业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,36"
    }
  }, [_vm._v("汽车制造业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,37"
    }
  }, [_vm._v("铁路、船舶、航空航天和其他运输设备制造业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,38"
    }
  }, [_vm._v("电气机械和器材制造业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,39"
    }
  }, [_vm._v("计算机、通信和其他电子设备制造业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,40"
    }
  }, [_vm._v("仪器仪表制造业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,41"
    }
  }, [_vm._v("其他制造业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,42"
    }
  }, [_vm._v("废弃资源综合利用业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=C,43"
    }
  }, [_vm._v("金属制品、机械和设备修理业")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=D"
    }
  }, [_vm._v("电力、热力、燃气及水生产")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=D,44"
    }
  }, [_vm._v("电力、热力生产和供应业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=D,45"
    }
  }, [_vm._v("燃气生产和供应业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=D,46"
    }
  }, [_vm._v("水的生产和供应业")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=E"
    }
  }, [_vm._v("建筑业")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=E,47"
    }
  }, [_vm._v("房屋建筑业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=E,48"
    }
  }, [_vm._v("土木工程建筑业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=E,49"
    }
  }, [_vm._v("建筑安装业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=E,50"
    }
  }, [_vm._v("建筑装饰、装修和其他建筑业")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=F"
    }
  }, [_vm._v("批发和零售业")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=F,51"
    }
  }, [_vm._v("批发业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=F,52"
    }
  }, [_vm._v("零售业")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=G"
    }
  }, [_vm._v("交通运输、仓储和邮政业")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=G,53"
    }
  }, [_vm._v("铁路运输业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=G,54"
    }
  }, [_vm._v("道路运输业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=G,55"
    }
  }, [_vm._v("水上运输业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=G,56"
    }
  }, [_vm._v("航空运输业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=G,57"
    }
  }, [_vm._v("管道运输业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=G,58"
    }
  }, [_vm._v("多式联运和运输代理业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=G,59"
    }
  }, [_vm._v("装卸搬运和仓储业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=G,60"
    }
  }, [_vm._v("邮政业")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=H"
    }
  }, [_vm._v("住宿和餐饮业")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=H,61"
    }
  }, [_vm._v("住宿业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=H,62"
    }
  }, [_vm._v("餐饮业")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=I"
    }
  }, [_vm._v("信息传输、软件和信息技术")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=I,63"
    }
  }, [_vm._v("电信、广播电视和卫星传输服务")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=I,64"
    }
  }, [_vm._v("互联网和相关服务")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=I,65"
    }
  }, [_vm._v("软件和信息技术服务业")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=J"
    }
  }, [_vm._v("金融业")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=J,66"
    }
  }, [_vm._v("货币金融服务")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=J,67"
    }
  }, [_vm._v("资本市场服务")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=J,68"
    }
  }, [_vm._v("保险业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=J,69"
    }
  }, [_vm._v("其他金融业")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=K"
    }
  }, [_vm._v("房地产业")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=K,70"
    }
  }, [_vm._v("房地产业")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=L"
    }
  }, [_vm._v("租赁和商务服务业")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=L,71"
    }
  }, [_vm._v("租赁业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=L,72"
    }
  }, [_vm._v("商务服务业")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=M"
    }
  }, [_vm._v("科学研究和技术服务业")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=M,73"
    }
  }, [_vm._v("研究和试验发展")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=M,74"
    }
  }, [_vm._v("专业技术服务业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=M,75"
    }
  }, [_vm._v("科技推广和应用服务业")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=N"
    }
  }, [_vm._v("水利、环境和公共设施管理业")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=N,76"
    }
  }, [_vm._v("水利管理业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=N,77"
    }
  }, [_vm._v("生态保护和环境治理业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=N,78"
    }
  }, [_vm._v("公共设施管理业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=N,79"
    }
  }, [_vm._v("土地管理业")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=O"
    }
  }, [_vm._v("居民服务、修理和其他服务业")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=O,80"
    }
  }, [_vm._v("居民服务业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=O,81"
    }
  }, [_vm._v("机动车、电子产品和日用产品修理业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=O,82"
    }
  }, [_vm._v("其他服务业")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=P"
    }
  }, [_vm._v("教育")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=P,83"
    }
  }, [_vm._v("教育")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=Q"
    }
  }, [_vm._v("卫生和社会工作")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=Q,84"
    }
  }, [_vm._v("卫生")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=Q,85"
    }
  }, [_vm._v("社会工作")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=R"
    }
  }, [_vm._v("文化、体育和娱乐业")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=R,86"
    }
  }, [_vm._v("新闻和出版业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=R,87"
    }
  }, [_vm._v("广播、电视、电影和录音制作业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=R,88"
    }
  }, [_vm._v("文化艺术业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=R,89"
    }
  }, [_vm._v("体育")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=R,90"
    }
  }, [_vm._v("娱乐业")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=S"
    }
  }, [_vm._v("公共管理、社会保障")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=S,91"
    }
  }, [_vm._v("中国共产党机关")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=S,92"
    }
  }, [_vm._v("国家机构")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=S,93"
    }
  }, [_vm._v("人民政协、民主党派")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=S,94"
    }
  }, [_vm._v("社会保障")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=S,95"
    }
  }, [_vm._v("群众团体、社会团体和其他成员组织")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=S,96"
    }
  }, [_vm._v("基层群众自治组织及其他组织")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=T"
    }
  }, [_vm._v("国际组织")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?indus=T,97"
    }
  }, [_vm._v("国际组织")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.panel == 'area') ? _c('div', {
    staticClass: "content-box p-3"
  }, [_c('div', {
    staticClass: "panel-list-right"
  }, [_c('div', {
    staticClass: "city-list"
  }, [_c('div', {
    staticClass: "city"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=北京市"
    }
  }, [_vm._v("北京市")])]), _vm._v(" "), _c('div', {
    staticClass: "city"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=天津市"
    }
  }, [_vm._v("天津市")])]), _vm._v(" "), _c('div', {
    staticClass: "city"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=上海市"
    }
  }, [_vm._v("上海市")])]), _vm._v(" "), _c('div', {
    staticClass: "city"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=重庆市"
    }
  }, [_vm._v("重庆市")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-list"
  }, [_c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=广东省"
    }
  }, [_vm._v("广东省")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=广州市"
    }
  }, [_vm._v("广州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=韶关市"
    }
  }, [_vm._v("韶关")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=深圳市"
    }
  }, [_vm._v("深圳")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=珠海市"
    }
  }, [_vm._v("珠海")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=汕头市"
    }
  }, [_vm._v("汕头")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=佛山市"
    }
  }, [_vm._v("佛山")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=江门市"
    }
  }, [_vm._v("江门")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=湛江市"
    }
  }, [_vm._v("湛江")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=茂名市"
    }
  }, [_vm._v("茂名")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=肇庆市"
    }
  }, [_vm._v("肇庆")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=惠州市"
    }
  }, [_vm._v("惠州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=梅州市"
    }
  }, [_vm._v("梅州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=汕尾市"
    }
  }, [_vm._v("汕尾")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=河源市"
    }
  }, [_vm._v("河源")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=阳江市"
    }
  }, [_vm._v("阳江")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=清远市"
    }
  }, [_vm._v("清远")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=潮州市"
    }
  }, [_vm._v("潮州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=揭阳市"
    }
  }, [_vm._v("揭阳")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=云浮市"
    }
  }, [_vm._v("云浮")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=中山市"
    }
  }, [_vm._v("中山")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=东莞市"
    }
  }, [_vm._v("东莞")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=江苏省"
    }
  }, [_vm._v("江苏省")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=南京市"
    }
  }, [_vm._v("南京")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=无锡市"
    }
  }, [_vm._v("无锡")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=徐州市"
    }
  }, [_vm._v("徐州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=常州市"
    }
  }, [_vm._v("常州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=苏州市"
    }
  }, [_vm._v("苏州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=南通市"
    }
  }, [_vm._v("南通")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=连云港市"
    }
  }, [_vm._v("连云港")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=淮安市"
    }
  }, [_vm._v("淮安")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=盐城市"
    }
  }, [_vm._v("盐城")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=扬州市"
    }
  }, [_vm._v("扬州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=镇江市"
    }
  }, [_vm._v("镇江")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=泰州市"
    }
  }, [_vm._v("泰州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=宿迁市"
    }
  }, [_vm._v("宿迁")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=山东省"
    }
  }, [_vm._v("山东省")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=济南市"
    }
  }, [_vm._v("济南")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=青岛市"
    }
  }, [_vm._v("青岛")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=淄博市"
    }
  }, [_vm._v("淄博")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=枣庄市"
    }
  }, [_vm._v("枣庄")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=东营市"
    }
  }, [_vm._v("东营")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=烟台市"
    }
  }, [_vm._v("烟台")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=潍坊市"
    }
  }, [_vm._v("潍坊")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=济宁市"
    }
  }, [_vm._v("济宁")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=泰安市"
    }
  }, [_vm._v("泰安")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=威海市"
    }
  }, [_vm._v("威海")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=日照市"
    }
  }, [_vm._v("日照")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=临沂市"
    }
  }, [_vm._v("临沂")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=德州市"
    }
  }, [_vm._v("德州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=聊城市"
    }
  }, [_vm._v("聊城")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=滨州市"
    }
  }, [_vm._v("滨州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=菏泽市"
    }
  }, [_vm._v("菏泽")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=浙江省"
    }
  }, [_vm._v("浙江省")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=杭州市"
    }
  }, [_vm._v("杭州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=宁波市"
    }
  }, [_vm._v("宁波")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=温州市"
    }
  }, [_vm._v("温州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=嘉兴市"
    }
  }, [_vm._v("嘉兴")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=湖州市"
    }
  }, [_vm._v("湖州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=绍兴市"
    }
  }, [_vm._v("绍兴")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=金华市"
    }
  }, [_vm._v("金华")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=衢州市"
    }
  }, [_vm._v("衢州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=舟山市"
    }
  }, [_vm._v("舟山")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=台州市"
    }
  }, [_vm._v("台州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=丽水市"
    }
  }, [_vm._v("丽水")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=河北省"
    }
  }, [_vm._v("河北省")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=石家庄市"
    }
  }, [_vm._v("石家庄")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=唐山市"
    }
  }, [_vm._v("唐山")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=秦皇岛市"
    }
  }, [_vm._v("秦皇岛")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=邯郸市"
    }
  }, [_vm._v("邯郸")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=邢台市"
    }
  }, [_vm._v("邢台")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=保定市"
    }
  }, [_vm._v("保定")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=张家口市"
    }
  }, [_vm._v("张家口")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=承德市"
    }
  }, [_vm._v("承德")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=沧州市"
    }
  }, [_vm._v("沧州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=廊坊市"
    }
  }, [_vm._v("廊坊")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=衡水市"
    }
  }, [_vm._v("衡水")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=雄安新区"
    }
  }, [_vm._v("雄安新区")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=内蒙古自治区"
    }
  }, [_vm._v("内蒙古自治区")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=呼和浩特市"
    }
  }, [_vm._v("呼和浩特")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=包头市"
    }
  }, [_vm._v("包头")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=乌海市"
    }
  }, [_vm._v("乌海")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=赤峰市"
    }
  }, [_vm._v("赤峰")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=通辽市"
    }
  }, [_vm._v("通辽")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=鄂尔多斯市"
    }
  }, [_vm._v("鄂尔多斯")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=呼伦贝尔市"
    }
  }, [_vm._v("呼伦贝尔")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=巴彦淖尔市"
    }
  }, [_vm._v("巴彦淖尔")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=乌兰察布市"
    }
  }, [_vm._v("乌兰察布")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=兴安盟"
    }
  }, [_vm._v("兴安盟")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=锡林郭勒盟"
    }
  }, [_vm._v("锡林郭勒盟")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=阿拉善盟"
    }
  }, [_vm._v("阿拉善盟")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=辽宁省"
    }
  }, [_vm._v("辽宁省")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=沈阳市"
    }
  }, [_vm._v("沈阳")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=大连市"
    }
  }, [_vm._v("大连")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=鞍山市"
    }
  }, [_vm._v("鞍山")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=抚顺市"
    }
  }, [_vm._v("抚顺")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=本溪市"
    }
  }, [_vm._v("本溪")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=丹东市"
    }
  }, [_vm._v("丹东")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=锦州市"
    }
  }, [_vm._v("锦州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=营口市"
    }
  }, [_vm._v("营口")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=阜新市"
    }
  }, [_vm._v("阜新")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=辽阳市"
    }
  }, [_vm._v("辽阳")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=盘锦市"
    }
  }, [_vm._v("盘锦")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=铁岭市"
    }
  }, [_vm._v("铁岭")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=朝阳市"
    }
  }, [_vm._v("朝阳")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=葫芦岛市"
    }
  }, [_vm._v("葫芦岛")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=吉林省"
    }
  }, [_vm._v("吉林省")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=长春市"
    }
  }, [_vm._v("长春")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=吉林市"
    }
  }, [_vm._v("吉林")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=四平市"
    }
  }, [_vm._v("四平")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=辽源市"
    }
  }, [_vm._v("辽源")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=通化市"
    }
  }, [_vm._v("通化")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=白山市"
    }
  }, [_vm._v("白山")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=松原市"
    }
  }, [_vm._v("松原")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=白城市"
    }
  }, [_vm._v("白城")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=延边朝鲜族自治州"
    }
  }, [_vm._v("延边朝鲜族自治州")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=黑龙江省"
    }
  }, [_vm._v("黑龙江省")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=哈尔滨市"
    }
  }, [_vm._v("哈尔滨")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=齐齐哈尔市"
    }
  }, [_vm._v("齐齐哈尔")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=鸡西市"
    }
  }, [_vm._v("鸡西")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=鹤岗市"
    }
  }, [_vm._v("鹤岗")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=双鸭山市"
    }
  }, [_vm._v("双鸭山")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=大庆市"
    }
  }, [_vm._v("大庆")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=伊春市"
    }
  }, [_vm._v("伊春")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=佳木斯市"
    }
  }, [_vm._v("佳木斯")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=七台河市"
    }
  }, [_vm._v("七台河")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=牡丹江市"
    }
  }, [_vm._v("牡丹江")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=黑河市"
    }
  }, [_vm._v("黑河")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=绥化市"
    }
  }, [_vm._v("绥化")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=大兴安岭地区"
    }
  }, [_vm._v("大兴安岭地区")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=山西省"
    }
  }, [_vm._v("山西省")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=太原市"
    }
  }, [_vm._v("太原")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=大同市"
    }
  }, [_vm._v("大同")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=阳泉市"
    }
  }, [_vm._v("阳泉")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=长治市"
    }
  }, [_vm._v("长治")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=晋城市"
    }
  }, [_vm._v("晋城")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=朔州市"
    }
  }, [_vm._v("朔州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=晋中市"
    }
  }, [_vm._v("晋中")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=运城市"
    }
  }, [_vm._v("运城")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=忻州市"
    }
  }, [_vm._v("忻州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=临汾市"
    }
  }, [_vm._v("临汾")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=吕梁市"
    }
  }, [_vm._v("吕梁")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=河南省"
    }
  }, [_vm._v("河南省")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=郑州市"
    }
  }, [_vm._v("郑州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=开封市"
    }
  }, [_vm._v("开封")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=洛阳市"
    }
  }, [_vm._v("洛阳")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=平顶山市"
    }
  }, [_vm._v("平顶山")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=安阳市"
    }
  }, [_vm._v("安阳")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=鹤壁市"
    }
  }, [_vm._v("鹤壁")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=新乡市"
    }
  }, [_vm._v("新乡")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=焦作市"
    }
  }, [_vm._v("焦作")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=濮阳市"
    }
  }, [_vm._v("濮阳")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=许昌市"
    }
  }, [_vm._v("许昌")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=漯河市"
    }
  }, [_vm._v("漯河")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=三门峡市"
    }
  }, [_vm._v("三门峡")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=南阳市"
    }
  }, [_vm._v("南阳")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=商丘市"
    }
  }, [_vm._v("商丘")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=信阳市"
    }
  }, [_vm._v("信阳")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=周口市"
    }
  }, [_vm._v("周口")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=驻马店市"
    }
  }, [_vm._v("驻马店")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=省直辖县级行政区划"
    }
  }, [_vm._v("省直辖县级行政区划")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=安徽省"
    }
  }, [_vm._v("安徽省")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=合肥市"
    }
  }, [_vm._v("合肥")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=芜湖市"
    }
  }, [_vm._v("芜湖")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=蚌埠市"
    }
  }, [_vm._v("蚌埠")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=淮南市"
    }
  }, [_vm._v("淮南")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=马鞍山市"
    }
  }, [_vm._v("马鞍山")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=淮北市"
    }
  }, [_vm._v("淮北")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=铜陵市"
    }
  }, [_vm._v("铜陵")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=安庆市"
    }
  }, [_vm._v("安庆")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=黄山市"
    }
  }, [_vm._v("黄山")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=滁州市"
    }
  }, [_vm._v("滁州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=阜阳市"
    }
  }, [_vm._v("阜阳")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=宿州市"
    }
  }, [_vm._v("宿州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=六安市"
    }
  }, [_vm._v("六安")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=亳州市"
    }
  }, [_vm._v("亳州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=池州市"
    }
  }, [_vm._v("池州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=宣城市"
    }
  }, [_vm._v("宣城")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=福建省"
    }
  }, [_vm._v("福建省")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=福州市"
    }
  }, [_vm._v("福州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=厦门市"
    }
  }, [_vm._v("厦门")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=莆田市"
    }
  }, [_vm._v("莆田")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=三明市"
    }
  }, [_vm._v("三明")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=泉州市"
    }
  }, [_vm._v("泉州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=漳州市"
    }
  }, [_vm._v("漳州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=南平市"
    }
  }, [_vm._v("南平")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=龙岩市"
    }
  }, [_vm._v("龙岩")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=宁德市"
    }
  }, [_vm._v("宁德")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=湖北省"
    }
  }, [_vm._v("湖北省")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=武汉市"
    }
  }, [_vm._v("武汉")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=黄石市"
    }
  }, [_vm._v("黄石")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=十堰市"
    }
  }, [_vm._v("十堰")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=宜昌市"
    }
  }, [_vm._v("宜昌")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=襄阳市"
    }
  }, [_vm._v("襄阳")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=鄂州市"
    }
  }, [_vm._v("鄂州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=荆门市"
    }
  }, [_vm._v("荆门")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=孝感市"
    }
  }, [_vm._v("孝感")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=荆州市"
    }
  }, [_vm._v("荆州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=黄冈市"
    }
  }, [_vm._v("黄冈")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=咸宁市"
    }
  }, [_vm._v("咸宁")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=随州市"
    }
  }, [_vm._v("随州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=恩施土家族苗族自治州"
    }
  }, [_vm._v("恩施土家族苗族自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=省直辖县级行政区划"
    }
  }, [_vm._v("省直辖县级行政区划")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=湖南省"
    }
  }, [_vm._v("湖南省")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=长沙市"
    }
  }, [_vm._v("长沙")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=株洲市"
    }
  }, [_vm._v("株洲")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=湘潭市"
    }
  }, [_vm._v("湘潭")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=衡阳市"
    }
  }, [_vm._v("衡阳")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=邵阳市"
    }
  }, [_vm._v("邵阳")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=岳阳市"
    }
  }, [_vm._v("岳阳")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=常德市"
    }
  }, [_vm._v("常德")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=张家界市"
    }
  }, [_vm._v("张家界")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=益阳市"
    }
  }, [_vm._v("益阳")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=郴州市"
    }
  }, [_vm._v("郴州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=永州市"
    }
  }, [_vm._v("永州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=怀化市"
    }
  }, [_vm._v("怀化")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=娄底市"
    }
  }, [_vm._v("娄底")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=湘西土家族苗族自治州"
    }
  }, [_vm._v("湘西土家族苗族自治州")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=江西省"
    }
  }, [_vm._v("江西省")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=南昌市"
    }
  }, [_vm._v("南昌")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=景德镇市"
    }
  }, [_vm._v("景德镇")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=萍乡市"
    }
  }, [_vm._v("萍乡")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=九江市"
    }
  }, [_vm._v("九江")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=新余市"
    }
  }, [_vm._v("新余")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=鹰潭市"
    }
  }, [_vm._v("鹰潭")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=赣州市"
    }
  }, [_vm._v("赣州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=吉安市"
    }
  }, [_vm._v("吉安")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=宜春市"
    }
  }, [_vm._v("宜春")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=抚州市"
    }
  }, [_vm._v("抚州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=上饶市"
    }
  }, [_vm._v("上饶")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=广西壮族自治区"
    }
  }, [_vm._v("广西壮族自治区")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=南宁市"
    }
  }, [_vm._v("南宁")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=柳州市"
    }
  }, [_vm._v("柳州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=桂林市"
    }
  }, [_vm._v("桂林")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=梧州市"
    }
  }, [_vm._v("梧州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=北海市"
    }
  }, [_vm._v("北海")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=防城港市"
    }
  }, [_vm._v("防城港")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=钦州市"
    }
  }, [_vm._v("钦州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=贵港市"
    }
  }, [_vm._v("贵港")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=玉林市"
    }
  }, [_vm._v("玉林")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=百色市"
    }
  }, [_vm._v("百色")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=贺州市"
    }
  }, [_vm._v("贺州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=河池市"
    }
  }, [_vm._v("河池")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=来宾市"
    }
  }, [_vm._v("来宾")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=崇左市"
    }
  }, [_vm._v("崇左")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=海南省"
    }
  }, [_vm._v("海南省")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=海口市"
    }
  }, [_vm._v("海口")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=三亚市"
    }
  }, [_vm._v("三亚")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=三沙市"
    }
  }, [_vm._v("三沙")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=儋州市"
    }
  }, [_vm._v("儋州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=省直辖县级行政区划"
    }
  }, [_vm._v("省直辖县级行政区划")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=四川省"
    }
  }, [_vm._v("四川省")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=成都市"
    }
  }, [_vm._v("成都")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=自贡市"
    }
  }, [_vm._v("自贡")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=攀枝花市"
    }
  }, [_vm._v("攀枝花")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=泸州市"
    }
  }, [_vm._v("泸州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=德阳市"
    }
  }, [_vm._v("德阳")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=绵阳市"
    }
  }, [_vm._v("绵阳")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=广元市"
    }
  }, [_vm._v("广元")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=遂宁市"
    }
  }, [_vm._v("遂宁")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=内江市"
    }
  }, [_vm._v("内江")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=乐山市"
    }
  }, [_vm._v("乐山")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=南充市"
    }
  }, [_vm._v("南充")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=眉山市"
    }
  }, [_vm._v("眉山")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=宜宾市"
    }
  }, [_vm._v("宜宾")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=广安市"
    }
  }, [_vm._v("广安")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=达州市"
    }
  }, [_vm._v("达州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=雅安市"
    }
  }, [_vm._v("雅安")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=巴中市"
    }
  }, [_vm._v("巴中")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=资阳市"
    }
  }, [_vm._v("资阳")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=阿坝藏族羌族自治州"
    }
  }, [_vm._v("阿坝藏族羌族自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=甘孜藏族自治州"
    }
  }, [_vm._v("甘孜藏族自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=凉山彝族自治州"
    }
  }, [_vm._v("凉山彝族自治州")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=贵州省"
    }
  }, [_vm._v("贵州省")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=贵阳市"
    }
  }, [_vm._v("贵阳")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=六盘水市"
    }
  }, [_vm._v("六盘水")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=遵义市"
    }
  }, [_vm._v("遵义")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=安顺市"
    }
  }, [_vm._v("安顺")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=毕节市"
    }
  }, [_vm._v("毕节")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=铜仁市"
    }
  }, [_vm._v("铜仁")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=黔西南布依族苗族自治州"
    }
  }, [_vm._v("黔西南布依族苗族自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=黔东南苗族侗族自治州"
    }
  }, [_vm._v("黔东南苗族侗族自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=黔南布依族苗族自治州"
    }
  }, [_vm._v("黔南布依族苗族自治州")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=云南省"
    }
  }, [_vm._v("云南省")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=昆明市"
    }
  }, [_vm._v("昆明")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=曲靖市"
    }
  }, [_vm._v("曲靖")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=玉溪市"
    }
  }, [_vm._v("玉溪")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=保山市"
    }
  }, [_vm._v("保山")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=昭通市"
    }
  }, [_vm._v("昭通")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=丽江市"
    }
  }, [_vm._v("丽江")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=普洱市"
    }
  }, [_vm._v("普洱")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=临沧市"
    }
  }, [_vm._v("临沧")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=楚雄彝族自治州"
    }
  }, [_vm._v("楚雄彝族自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=红河哈尼族彝族自治州"
    }
  }, [_vm._v("红河哈尼族彝族自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=文山壮族苗族自治州"
    }
  }, [_vm._v("文山壮族苗族自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=西双版纳傣族自治州"
    }
  }, [_vm._v("西双版纳傣族自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=大理白族自治州"
    }
  }, [_vm._v("大理白族自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=德宏傣族景颇族自治州"
    }
  }, [_vm._v("德宏傣族景颇族自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=怒江傈僳族自治州"
    }
  }, [_vm._v("怒江傈僳族自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=迪庆藏族自治州"
    }
  }, [_vm._v("迪庆藏族自治州")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=陕西省"
    }
  }, [_vm._v("陕西省")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=西安市"
    }
  }, [_vm._v("西安")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=铜川市"
    }
  }, [_vm._v("铜川")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=宝鸡市"
    }
  }, [_vm._v("宝鸡")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=咸阳市"
    }
  }, [_vm._v("咸阳")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=渭南市"
    }
  }, [_vm._v("渭南")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=延安市"
    }
  }, [_vm._v("延安")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=汉中市"
    }
  }, [_vm._v("汉中")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=榆林市"
    }
  }, [_vm._v("榆林")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=安康市"
    }
  }, [_vm._v("安康")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=商洛市"
    }
  }, [_vm._v("商洛")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=甘肃省"
    }
  }, [_vm._v("甘肃省")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=兰州市"
    }
  }, [_vm._v("兰州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=嘉峪关市"
    }
  }, [_vm._v("嘉峪关")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=金昌市"
    }
  }, [_vm._v("金昌")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=白银市"
    }
  }, [_vm._v("白银")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=天水市"
    }
  }, [_vm._v("天水")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=武威市"
    }
  }, [_vm._v("武威")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=张掖市"
    }
  }, [_vm._v("张掖")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=平凉市"
    }
  }, [_vm._v("平凉")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=酒泉市"
    }
  }, [_vm._v("酒泉")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=庆阳市"
    }
  }, [_vm._v("庆阳")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=定西市"
    }
  }, [_vm._v("定西")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=陇南市"
    }
  }, [_vm._v("陇南")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=临夏回族自治州"
    }
  }, [_vm._v("临夏回族自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=甘南藏族自治州"
    }
  }, [_vm._v("甘南藏族自治州")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=宁夏回族自治区"
    }
  }, [_vm._v("宁夏回族自治区")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=银川市"
    }
  }, [_vm._v("银川")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=石嘴山市"
    }
  }, [_vm._v("石嘴山")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=吴忠市"
    }
  }, [_vm._v("吴忠")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=固原市"
    }
  }, [_vm._v("固原")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=中卫市"
    }
  }, [_vm._v("中卫")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=新疆维吾尔自治区"
    }
  }, [_vm._v("新疆维吾尔自治区")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=乌鲁木齐市"
    }
  }, [_vm._v("乌鲁木齐")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=克拉玛依市"
    }
  }, [_vm._v("克拉玛依")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=吐鲁番市"
    }
  }, [_vm._v("吐鲁番")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=哈密市"
    }
  }, [_vm._v("哈密")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=昌吉回族自治州"
    }
  }, [_vm._v("昌吉回族自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=博尔塔拉蒙古自治州"
    }
  }, [_vm._v("博尔塔拉蒙古自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=巴音郭楞蒙古自治州"
    }
  }, [_vm._v("巴音郭楞蒙古自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=阿克苏地区"
    }
  }, [_vm._v("阿克苏地区")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=克孜勒苏柯尔克孜自治州"
    }
  }, [_vm._v("克孜勒苏柯尔克孜自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=喀什地区"
    }
  }, [_vm._v("喀什地区")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=和田地区"
    }
  }, [_vm._v("和田地区")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=伊犁哈萨克自治州"
    }
  }, [_vm._v("伊犁哈萨克自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=塔城地区"
    }
  }, [_vm._v("塔城地区")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=阿勒泰地区"
    }
  }, [_vm._v("阿勒泰地区")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=自治区直辖县级行政区划"
    }
  }, [_vm._v("自治区直辖县级行政区划")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=青海省"
    }
  }, [_vm._v("青海省")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=西宁市"
    }
  }, [_vm._v("西宁")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=海东市"
    }
  }, [_vm._v("海东")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=海北藏族自治州"
    }
  }, [_vm._v("海北藏族自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=黄南藏族自治州"
    }
  }, [_vm._v("黄南藏族自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=海南藏族自治州"
    }
  }, [_vm._v("海南藏族自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=果洛藏族自治州"
    }
  }, [_vm._v("果洛藏族自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=玉树藏族自治州"
    }
  }, [_vm._v("玉树藏族自治州")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=海西蒙古族藏族自治州"
    }
  }, [_vm._v("海西蒙古族藏族自治州")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?prov=西藏自治区"
    }
  }, [_vm._v("西藏自治区")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=拉萨市"
    }
  }, [_vm._v("拉萨")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=日喀则市"
    }
  }, [_vm._v("日喀则")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=昌都市"
    }
  }, [_vm._v("昌都")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=林芝市"
    }
  }, [_vm._v("林芝")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=山南市"
    }
  }, [_vm._v("山南")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=那曲市"
    }
  }, [_vm._v("那曲")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/boss?city=阿里地区"
    }
  }, [_vm._v("阿里地区")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.panel == 'chain') ? _c('div', {
    staticClass: "content-box p-3"
  }, [_c('div', {
    staticClass: "panel-list-right"
  }, [_c('div', {
    staticClass: "panel-list"
  }, [_c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_vm._v("装备制造")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13910"
    }
  }, [_vm._v("海洋工程装备")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13875"
    }
  }, [_vm._v("高端装备制造")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13898"
    }
  }, [_vm._v("智能制造")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13894"
    }
  }, [_vm._v("新材料")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13896"
    }
  }, [_vm._v("石墨烯")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13897"
    }
  }, [_vm._v("高分子材料")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13928"
    }
  }, [_vm._v("氟化工")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13877"
    }
  }, [_vm._v("精细化工")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13900"
    }
  }, [_vm._v("商业航天")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13882"
    }
  }, [_vm._v("轨道交通装备")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13922"
    }
  }, [_vm._v("数控机床")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13919"
    }
  }, [_vm._v("工程机械")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13948"
    }
  }, [_vm._v("轨道交通")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13963"
    }
  }, [_vm._v("航空发动机")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13979"
    }
  }, [_vm._v("精密仪器仪表")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13982"
    }
  }, [_vm._v("大飞机产业")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_vm._v("能源化工")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13885"
    }
  }, [_vm._v("稀土")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13912"
    }
  }, [_vm._v("石油化工")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13913"
    }
  }, [_vm._v("煤化工")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13914"
    }
  }, [_vm._v("危险化学品")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13918"
    }
  }, [_vm._v("特高压")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13932"
    }
  }, [_vm._v("钢铁")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13947"
    }
  }, [_vm._v("煤炭")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13969"
    }
  }, [_vm._v("铝及铝合金")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13980"
    }
  }, [_vm._v("有色金属")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13974"
    }
  }, [_vm._v("有色冶金")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13951"
    }
  }, [_vm._v("有机硅")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13942"
    }
  }, [_vm._v("橡胶")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13958"
    }
  }, [_vm._v("镁产业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13968"
    }
  }, [_vm._v("电力")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13988"
    }
  }, [_vm._v("铜产业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13975"
    }
  }, [_vm._v("培育钻石")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13976"
    }
  }, [_vm._v("玻璃")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_vm._v("科技")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13888"
    }
  }, [_vm._v("工业互联网")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13903"
    }
  }, [_vm._v("物联网")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13915"
    }
  }, [_vm._v("软件和信息技术服务业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13893"
    }
  }, [_vm._v("元宇宙")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13899"
    }
  }, [_vm._v("人工智能")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13950"
    }
  }, [_vm._v("量子通信")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13953"
    }
  }, [_vm._v("可穿戴设备")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13878"
    }
  }, [_vm._v("数字经济")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13890"
    }
  }, [_vm._v("集成电路")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13955"
    }
  }, [_vm._v("云计算")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13978"
    }
  }, [_vm._v("智能安防")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13986"
    }
  }, [_vm._v("VR")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13995"
    }
  }, [_vm._v("大数据")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13981"
    }
  }, [_vm._v("电子信息")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13965"
    }
  }, [_vm._v("数字安全")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13930"
    }
  }, [_vm._v("智慧交通")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13927"
    }
  }, [_vm._v("区块链")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13908"
    }
  }, [_vm._v("新型显示")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13911"
    }
  }, [_vm._v("5G")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13961"
    }
  }, [_vm._v("光通信")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13990"
    }
  }, [_vm._v("光学薄膜")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_vm._v("生物医药")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13889"
    }
  }, [_vm._v("生物医药")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13879"
    }
  }, [_vm._v("疫苗")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13916"
    }
  }, [_vm._v("医疗器械")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13917"
    }
  }, [_vm._v("中药材")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13960"
    }
  }, [_vm._v("医疗美容")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13966"
    }
  }, [_vm._v("化妆品")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13962"
    }
  }, [_vm._v("仿制药")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13971"
    }
  }, [_vm._v("海洋生物医药")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13925"
    }
  }, [_vm._v("食品加工")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13937"
    }
  }, [_vm._v("葡萄酒")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13959"
    }
  }, [_vm._v("白酒")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13957"
    }
  }, [_vm._v("茶叶")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13989"
    }
  }, [_vm._v("餐饮")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13987"
    }
  }, [_vm._v("烟草行业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13931"
    }
  }, [_vm._v("种子")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_vm._v("新能源")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13876"
    }
  }, [_vm._v("新能源")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13895"
    }
  }, [_vm._v("锂电池")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13902"
    }
  }, [_vm._v("充电桩")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13886"
    }
  }, [_vm._v("储能")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13906"
    }
  }, [_vm._v("风电")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13904"
    }
  }, [_vm._v("氢能")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13905"
    }
  }, [_vm._v("光伏")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13907"
    }
  }, [_vm._v("节能环保")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_vm._v("服务业")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13920"
    }
  }, [_vm._v("现代商贸")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13921"
    }
  }, [_vm._v("现代金融")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13923"
    }
  }, [_vm._v("现代物流")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13977"
    }
  }, [_vm._v("冷链物流产业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13924"
    }
  }, [_vm._v("现代海洋")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13909"
    }
  }, [_vm._v("现代农业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13938"
    }
  }, [_vm._v("商务服务")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13936"
    }
  }, [_vm._v("会展")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13939"
    }
  }, [_vm._v("文化")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13940"
    }
  }, [_vm._v("人力资源服务")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13941"
    }
  }, [_vm._v("教育")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13943"
    }
  }, [_vm._v("旅游")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13964"
    }
  }, [_vm._v("健康养老")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13956"
    }
  }, [_vm._v("体育")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13949"
    }
  }, [_vm._v("宠物经济")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13954"
    }
  }, [_vm._v("电子竞技")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13985"
    }
  }, [_vm._v("冰雪产业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13996"
    }
  }, [_vm._v("影视文化")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13984"
    }
  }, [_vm._v("工程服务")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13983"
    }
  }, [_vm._v("动漫")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_vm._v("制造业")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13944"
    }
  }, [_vm._v("增材制造设备")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13946"
    }
  }, [_vm._v("3D打印")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13945"
    }
  }, [_vm._v("农业机械产业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13967"
    }
  }, [_vm._v("装配式建筑")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13993"
    }
  }, [_vm._v("海洋运输")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13935"
    }
  }, [_vm._v("应急")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13926"
    }
  }, [_vm._v("绿色建材")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13992"
    }
  }, [_vm._v("先进陶瓷")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13991"
    }
  }, [_vm._v("造纸产业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13994"
    }
  }, [_vm._v("纺织机械")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13929"
    }
  }, [_vm._v("纺织服装")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_c('div', {
    staticClass: "tags"
  }, [_vm._v("汽车家电")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13892"
    }
  }, [_vm._v("机器人")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13883"
    }
  }, [_vm._v("工业机器人")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13884"
    }
  }, [_vm._v("服务机器人")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13952"
    }
  }, [_vm._v("扫地机器人")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13891"
    }
  }, [_vm._v("无人机")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13881"
    }
  }, [_vm._v("汽车")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13887"
    }
  }, [_vm._v("新能源汽车")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13901"
    }
  }, [_vm._v("无人驾驶汽车")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13970"
    }
  }, [_vm._v("军工电子")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13880"
    }
  }, [_vm._v("智能家电")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13933"
    }
  }, [_vm._v("家电")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13972"
    }
  }, [_vm._v("手机")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13973"
    }
  }, [_vm._v("家具")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/detail?id=13934"
    }
  }, [_vm._v("自行车")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.panel == 'tags') ? _c('div', {
    staticClass: "content-box p-3 panel-height"
  }, [_c('div', {
    staticClass: "panel-list-right"
  }, [_c('div', {
    staticClass: "panel-list"
  }, [_c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_vm._v("\n                                  科技型企业\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/result?tags=高新技术企业"
    }
  }, [_vm._v("高新技术企业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/result?tags=创新型中小企业"
    }
  }, [_vm._v("创新型中小企业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/result?tags=专精特新企业"
    }
  }, [_vm._v("专精特新企业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/result?tags=专精特新小巨人企业"
    }
  }, [_vm._v("专精特新小巨人企业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/result?tags=科技型中小企业"
    }
  }, [_vm._v("科技型中小企业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/result?tags=科技小巨人企业"
    }
  }, [_vm._v("科技小巨人企业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/result?tags=独角兽企业"
    }
  }, [_vm._v("独角兽企业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/result?tags=瞪羚企业"
    }
  }, [_vm._v("瞪羚企业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/result?tags=雏鹰企业"
    }
  }, [_vm._v("雏鹰企业")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/result?tags=隐形冠军企业"
    }
  }, [_vm._v("隐形冠军企业")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_vm._v("\n                                  上市公司\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=A股"
    }
  }, [_vm._v("A股上市")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=中概股"
    }
  }, [_vm._v("海外上市")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=科创版"
    }
  }, [_vm._v("科创版")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=新三板"
    }
  }, [_vm._v("新三板")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=新四板"
    }
  }, [_vm._v("新四板")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=北交所"
    }
  }, [_vm._v("北交所")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_vm._v("\n                                  融资信息\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=天使轮"
    }
  }, [_vm._v("天使轮")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=PreA至A"
    }
  }, [_vm._v("PreA至A")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=PreB至B"
    }
  }, [_vm._v("PreB至B")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=C轮及以上"
    }
  }, [_vm._v("C轮及以上")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=股权融资或转让"
    }
  }, [_vm._v("股权融资或转让")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=并购合并"
    }
  }, [_vm._v("并购合并")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=定向增发"
    }
  }, [_vm._v("定向增发")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=战略投资"
    }
  }, [_vm._v("战略投资")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_vm._v("\n                                  风险标签\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?blots=动产抵押"
    }
  }, [_vm._v("动产抵押")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?blots=股权出质"
    }
  }, [_vm._v("股权出质")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?blots=股权冻结"
    }
  }, [_vm._v("股权冻结")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?blots=经营异常"
    }
  }, [_vm._v("经营异常")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?blots=严重违法"
    }
  }, [_vm._v("严重违法")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?blots=税收违法"
    }
  }, [_vm._v("税收违法")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?blots=行政处罚"
    }
  }, [_vm._v("行政处罚")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_vm._v("\n                                  其他标签\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "portray"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=数字营销"
    }
  }, [_vm._v("数字营销")])]), _vm._v(" "), _c('div', {
    staticClass: "portray"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=整合营销"
    }
  }, [_vm._v("整合营销")])]), _vm._v(" "), _c('div', {
    staticClass: "portray"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=大数据"
    }
  }, [_vm._v("大数据")])]), _vm._v(" "), _c('div', {
    staticClass: "portray"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=数据治理"
    }
  }, [_vm._v("数据治理")])]), _vm._v(" "), _c('div', {
    staticClass: "portray"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=MCN"
    }
  }, [_vm._v("MCN")])]), _vm._v(" "), _c('div', {
    staticClass: "portray"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=AI"
    }
  }, [_vm._v("大模型")])]), _vm._v(" "), _c('div', {
    staticClass: "portray"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=人工智能"
    }
  }, [_vm._v("人工智能")])]), _vm._v(" "), _c('div', {
    staticClass: "portray"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=O2O"
    }
  }, [_vm._v("O2O")])]), _vm._v(" "), _c('div', {
    staticClass: "portray"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=金融科技"
    }
  }, [_vm._v("金融科技")])]), _vm._v(" "), _c('div', {
    staticClass: "portray"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=数据安全"
    }
  }, [_vm._v("数据安全")])]), _vm._v(" "), _c('div', {
    staticClass: "portray"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=信创"
    }
  }, [_vm._v("信创")])]), _vm._v(" "), _c('div', {
    staticClass: "portray"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=医疗健康"
    }
  }, [_vm._v("医疗健康")])]), _vm._v(" "), _c('div', {
    staticClass: "portray"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=软件外包"
    }
  }, [_vm._v("软件外包")])]), _vm._v(" "), _c('div', {
    staticClass: "portray"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=物联网"
    }
  }, [_vm._v("物联网")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.panel == 'rank') ? _c('div', {
    staticClass: "content-box p-3 panel-height"
  }, [_c('div', {
    staticClass: "panel-list-right"
  }, [_c('div', {
    staticClass: "panel-list"
  }, [_c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_vm._v("\n                                  人工智能\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/result?tags=字节跳动"
    }
  }, [_vm._v("字节跳动")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/result?tags=深圳市腾讯计算机系统有限公司"
    }
  }, [_vm._v("腾讯")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/result?tags=杭州深度求索人工智能基础技术研究有限公司"
    }
  }, [_vm._v("深度求索")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/result?tags=华为"
    }
  }, [_vm._v("华为")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/result?tags=阿里巴巴"
    }
  }, [_vm._v("阿里巴巴")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/result?tags=北京智谱华章科技有限公司"
    }
  }, [_vm._v("智谱华章")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/result?tags=百度"
    }
  }, [_vm._v("百度")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/result?tags=月之暗面科技有限公司"
    }
  }, [_vm._v("月之暗面")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/result?tags=科大讯飞股份有限公司"
    }
  }, [_vm._v("科大讯飞")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_vm._v("\n                                  机器人\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=宇树科技"
    }
  }, [_vm._v("宇树科技")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=优必选"
    }
  }, [_vm._v("优必选")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=科沃斯"
    }
  }, [_vm._v("科沃斯")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=大疆创新"
    }
  }, [_vm._v("大疆创新")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=新松机器人"
    }
  }, [_vm._v("新松机器人")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=埃斯顿"
    }
  }, [_vm._v("埃斯顿")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=达闼机器人"
    }
  }, [_vm._v("达闼机器人")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=达闼机器人"
    }
  }, [_vm._v("云鲸智能")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=达闼机器人"
    }
  }, [_vm._v("九号公司")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=达闼机器人"
    }
  }, [_vm._v("猎户星空")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=达闼机器人"
    }
  }, [_vm._v("思灵机器人")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_vm._v("\n                                  金融科技\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?blots=股权冻结"
    }
  }, [_vm._v("蚂蚁金服")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?blots=微众银行"
    }
  }, [_vm._v("微众银行")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?blots=京东科技"
    }
  }, [_vm._v("京东科技")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?blots=度小满金融"
    }
  }, [_vm._v("度小满金融")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?blots=中电金信"
    }
  }, [_vm._v("中电金信")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?blots=软通动力"
    }
  }, [_vm._v("软通动力")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?blots=百融云创"
    }
  }, [_vm._v("百融云创")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?blots=百融云创"
    }
  }, [_vm._v("神州信息")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?blots=百融云创"
    }
  }, [_vm._v("中科软")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_vm._v("\n                                  智能制造\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=数字营销"
    }
  }, [_vm._v("华为 FusionPlant")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=整合营销"
    }
  }, [_vm._v("海尔 卡奥斯 COSMOPlat")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=大数据"
    }
  }, [_vm._v("美的集团")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=数据治理"
    }
  }, [_vm._v("树根互联")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=MCN"
    }
  }, [_vm._v("汇川技术")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=AI"
    }
  }, [_vm._v("格创东智")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=人工智能"
    }
  }, [_vm._v("华工科技")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=O2O"
    }
  }, [_vm._v("埃夫特机器人")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=金融科技"
    }
  }, [_vm._v("天准科技")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "panel-name",
    staticStyle: {
      "min-width": "220px"
    }
  }, [_vm._v("\n                                  新能源\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-item"
  }, [_c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=宁德时代"
    }
  }, [_vm._v("宁德时代")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=比亚迪"
    }
  }, [_vm._v("比亚迪")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=中国广核"
    }
  }, [_vm._v("中国广核")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=华能国际"
    }
  }, [_vm._v("华能国际")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=亿纬锂能"
    }
  }, [_vm._v("亿纬锂能")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=上海电气"
    }
  }, [_vm._v("上海电气")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=金风科技"
    }
  }, [_vm._v("金风科技")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=阳光电源"
    }
  }, [_vm._v("阳光电源")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=隆基绿能"
    }
  }, [_vm._v("隆基绿能")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?portray=国轩高科"
    }
  }, [_vm._v("国轩高科")])])])])])])]) : _vm._e()])])])], 1)], 1)])])]), _vm._v(" "), _c('section', {
    staticClass: "common-collaboration-scenarios clearfix pc-hidden",
    staticStyle: {
      "background-color": "#efefef"
    }
  }, [_c('div', {
    staticClass: "scenarios-wrapper"
  }, [_c('div', {
    staticClass: "scenarios-title"
  }, [_vm._v("从获客到营销，覆盖企业常见业务场景")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "scenarios-desc"
  }, [_vm._v("给你想要的")]), _vm._v(" "), _c('div', {
    staticClass: "scenarios-content"
  }, [_c('ul', {
    staticClass: "scenarios-lists"
  }, [_c('li', {
    attrs: {
      "role": "button2"
    }
  }, [_c('div', {
    staticClass: "scene-header"
  }, [_vm._m(15), _c('span', {
    staticClass: "expand-icon d-block"
  }, [_c('i', {
    staticClass: "wt-icon-svg-component"
  }, [_c('svg', {
    attrs: {
      "fill": "currentColor"
    }
  }, [_c('use', {
    staticClass: "angle-icon",
    attrs: {
      "href": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "scene-body scene-body-hidden"
  }, [_c('div', {
    staticClass: "scene-desc"
  }, [_c('p', [_vm._v("\n                        全量3.27亿企业大数据库，2.1亿企业高管大数据库，100多个产业链，丰富的企业标签，支持批量导出，并提供大数据系统"), _c('font', {
    attrs: {
      "color": "#ff4500"
    }
  }, [_vm._v("私有化部署")]), _vm._v("服务，与客户自有数据无缝集成。")], 1)])])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "button2"
    }
  }, [_c('div', {
    staticClass: "scene-header"
  }, [_vm._m(16), _c('span', {
    staticClass: "expand-icon d-block"
  }, [_c('i', {
    staticClass: "wt-icon-svg-component"
  }, [_c('svg', {
    attrs: {
      "fill": "currentColor"
    }
  }, [_c('use', {
    staticClass: "angle-icon",
    attrs: {
      "href": ""
    }
  })])])])]), _vm._v(" "), _vm._m(17)]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "button2"
    }
  }, [_c('div', {
    staticClass: "scene-header"
  }, [_vm._m(18), _c('span', {
    staticClass: "expand-icon d-block"
  }, [_c('i', {
    staticClass: "wt-icon-svg-component"
  }, [_c('svg', {
    attrs: {
      "fill": "currentColor"
    }
  }, [_c('use', {
    staticClass: "angle-icon",
    attrs: {
      "href": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "scene-body scene-body-hidden"
  }, [_c('div', {
    staticClass: "scene-desc"
  }, [_c('p', [_vm._v("通过先进的AI算法和领先的数据挖掘平台，为多种业务场景生成开箱即用的数据集，性价比极高。")]), _vm._v(" "), _c('p', [_vm._v("\n                        在导出的数据中，我们会"), _c('font', {
    attrs: {
      "color": "#ff4500"
    }
  }, [_vm._v("精准标识")]), _vm._v("出有效的、高质量的联系方式以及无效的联系方式。让你找客户更加高效，为你节约大量时间成本。\n                      ")], 1)])])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "button2"
    }
  }, [_c('div', {
    staticClass: "scene-header"
  }, [_vm._m(19), _c('span', {
    staticClass: "expand-icon d-block"
  }, [_c('i', {
    staticClass: "wt-icon-svg-component"
  }, [_c('svg', {
    attrs: {
      "fill": "currentColor"
    }
  }, [_c('use', {
    staticClass: "angle-icon",
    attrs: {
      "href": ""
    }
  })])])])]), _vm._v(" "), _vm._m(20)]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "button2"
    }
  }, [_c('div', {
    staticClass: "scene-header"
  }, [_vm._m(21), _c('span', {
    staticClass: "expand-icon d-block"
  }, [_c('i', {
    staticClass: "wt-icon-svg-component"
  }, [_c('svg', {
    attrs: {
      "fill": "currentColor"
    }
  }, [_c('use', {
    staticClass: "angle-icon",
    attrs: {
      "href": ""
    }
  })])])])]), _vm._v(" "), _vm._m(22)]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "button2"
    }
  }, [_c('div', {
    staticClass: "scene-header"
  }, [_vm._m(23), _c('span', {
    staticClass: "expand-icon d-block"
  }, [_c('i', {
    staticClass: "wt-icon-svg-component"
  }, [_c('svg', {
    attrs: {
      "fill": "currentColor"
    }
  }, [_c('use', {
    staticClass: "angle-icon",
    attrs: {
      "href": ""
    }
  })])])])]), _vm._v(" "), _vm._m(24)])])])])]), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26)])]), _vm._v(" "), _c('home-footer'), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogAds,
      "width": "560px",
      "show-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogAds = $event
      }
    }
  }, [_c('div', {
    staticClass: "single-card pr-3 pl-3",
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('div', {
    staticClass: "single-card-title"
  }, [_c('div', {
    staticClass: "datawill-logo-text2 pb-2"
  }, [_vm._v("精准广告投放")])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "step-card"
  }, [_c('img', {
    staticClass: "step-image",
    attrs: {
      "src": "/static/img/ads1.jpg",
      "alt": "第一步图片"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "step-content"
  }, [_c('h2', [_c('i', {
    staticClass: "fa-1 pr-3"
  }, [_vm._v("1")]), _vm._v("人群定向")]), _vm._v(" "), _c('p', [_vm._v("\n                通过企业家大数据平台按行业、地区、企业规模、职位等条件筛选目标人群，将目标人群的OneID导出。（合法合规操作，不涉及任何隐私信息）")])])]), _vm._v(" "), _c('div', {
    staticClass: "step-card"
  }, [_c('img', {
    staticClass: "step-image",
    attrs: {
      "src": "/static/img/ads2.jpg",
      "alt": "第二步图片"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "step-content"
  }, [_c('h2', [_c('i', {
    staticClass: "fa-2 pr-3"
  }, [_vm._v("2")]), _vm._v("广告平台对接")]), _vm._v(" "), _c('p', [_vm._v("将导出的OneID列表上传到腾讯广告、巨量千川、小红书等在线广告平台，并授权给广告主，作为定向人群包使用。")])])]), _vm._v(" "), _c('div', {
    staticClass: "step-card"
  }, [_c('img', {
    staticClass: "step-image",
    attrs: {
      "src": "/static/img/ads3.jpg",
      "alt": "第三步图片"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "step-content"
  }, [_c('h2', [_c('i', {
    staticClass: "fa-3 pr-3"
  }, [_vm._v("3")]), _vm._v("精准投放")]), _vm._v(" "), _c('p', [_vm._v("\n                广告主创建广告，投放时选择定向人群包，实现对企业高管等特定商务人群的精准投放。多个案例证明，ToB业务精准人群投放比泛流量转化率提升50%以上。")])])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogCooperation,
      "width": "520px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogCooperation = $event
      }
    }
  }, [_c('div', {
    staticClass: "single-card pr-3 pl-3",
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('div', {
    staticClass: "single-card-title"
  }, [_c('div', {
    staticClass: "datawill-logo-text2 pb-2"
  }, [_vm._v("渠道合作")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "thy-input form-control",
    attrs: {
      "thysize": "lg",
      "pattern": "/^(\\+?0086\\-)?1[3456789]\\d{9}$/"
    }
  }, [_c('span', {
    staticClass: "input-label input-label-lg"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control-lg form-control width_200",
    attrs: {
      "placeholder": "请输入联系人名字"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "thy-input form-control",
    attrs: {
      "thysize": "lg"
    }
  }, [_c('span', {
    staticClass: "input-label input-label-lg"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.companyName),
      expression: "form.companyName"
    }],
    staticClass: "form-control-lg form-control",
    attrs: {
      "placeholder": "请输入公司名称"
    },
    domProps: {
      "value": (_vm.form.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "companyName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "thy-input form-control",
    attrs: {
      "thysize": "lg"
    }
  }, [_c('span', {
    staticClass: "input-label input-label-lg"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.title),
      expression: "form.title"
    }],
    staticClass: "form-control-lg form-control",
    attrs: {
      "placeholder": "请输入职位"
    },
    domProps: {
      "value": (_vm.form.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "thy-input form-control",
    attrs: {
      "thysize": "lg"
    }
  }, [_c('span', {
    staticClass: "input-label input-label-lg"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.phone),
      expression: "form.phone"
    }],
    staticClass: "form-control-lg form-control",
    attrs: {
      "placeholder": "请输入联系方式"
    },
    domProps: {
      "value": (_vm.form.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "phone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label mb-2"
  }, [_vm._v(" 合作内容 ")]), _vm._v(" "), _c('div', {
    attrs: {
      "thysize": "lg"
    }
  }, [_c('span', {
    staticClass: "input-label input-label-lg"
  }), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "数据产品",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "广告服务",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "数据源供应",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "其他",
      "name": "type"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "thy-input form-control",
    attrs: {
      "thysize": "lg"
    }
  }, [_c('span', {
    staticClass: "input-label input-label-lg"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.remark),
      expression: "form.remark"
    }],
    staticClass: "form-control-lg form-control",
    staticStyle: {
      "height": "4em",
      "vertical-align": "top"
    },
    attrs: {
      "placeholder": "留言",
      "type": "textarea"
    },
    domProps: {
      "value": (_vm.form.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "remark", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "single-card-actions form-group"
  }, [_c('div', {
    staticClass: "form-group-footer form-group-footer-align-left"
  }, [_c('div', {
    staticClass: "btn-pair form-footer-actions"
  }, [_c('button', {
    staticClass: "btn-block single-btn lg-btn btn btn-primary btn-square",
    on: {
      "click": _vm.submit_feedback
    }
  }, [_vm._v("提交\n                ")])])])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "意见反馈",
      "visible": _vm.dialogVisible,
      "width": "550px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "问题类型"
    }
  }, [_c('el-select', {
    staticClass: "item_w_200",
    attrs: {
      "placeholder": "请选择问题类型"
    },
    model: {
      value: (_vm.form.strType),
      callback: function($$v) {
        _vm.$set(_vm.form, "strType", $$v)
      },
      expression: "form.strType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "工商信息",
      "value": "ent_info"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "个人隐私信息",
      "value": "hum_info"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系方式"
    }
  }, [_c('el-input', {
    staticClass: "item_w_300",
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话回复"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.delivery),
      callback: function($$v) {
        _vm.$set(_vm.form, "delivery", $$v)
      },
      expression: "form.delivery"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "相关图片"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": "",
      "list-type": "picture-card"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "问题描述"
    }
  }, [_c('el-input', {
    staticClass: "item_w_400",
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.remark),
      callback: function($$v) {
        _vm.$set(_vm.form, "remark", $$v)
      },
      expression: "form.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit_feedback
    }
  }, [_vm._v("立即提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pc-show"
  }, [_c('h4', {
    staticClass: "section-title section-title--white experience-use-free-section-title slogan-main"
  }, [_vm._v("\n                高效找客户 智能拓商机")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h4', {
    staticClass: "section-title section-title--white mt-5"
  }, [_vm._v("\n                    高效找客户 智能拓商机")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quick_panel"
  }, [_c('a', {
    staticClass: "quick_left",
    staticStyle: {
      "background": "#ff952c"
    },
    attrs: {
      "href": "/#/pkgmobile"
    }
  }, [_c('div', [_vm._v("数据")]), _vm._v(" "), _c('div', [_vm._v("集市")])]), _vm._v(" "), _c('div', {
    staticClass: "quick_right"
  }, [_c('div', {
    staticClass: "quick_link"
  }, [_c('a', {
    attrs: {
      "href": "/#/pkg/btob?keyword=新疆野马"
    }
  }, [_vm._v("B2B领域：")]), _vm._v(" "), _c('a', {
    staticClass: "pl-0",
    attrs: {
      "href": "/#/pkg/btob?keyword=紫光集团"
    }
  }, [_vm._v("企业服务")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/pkg/btob?keyword=重庆帮企科技集团"
    }
  }, [_vm._v("招商")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/pkg/btob?keyword=品胜科技"
    }
  }, [_vm._v("展会")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/pkg/btob?keyword=数据处理"
    }
  }, [_vm._v("企业金融")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/pkg/btob?keyword=太阳能组件"
    }
  }, [_vm._v("知识产权服务 ...\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "quick_link"
  }, [_c('a', {
    attrs: {
      "href": "/#/ipr?keyword=SMC"
    }
  }, [_vm._v("B2C领域：")]), _vm._v(" "), _c('a', {
    staticClass: "pl-0",
    attrs: {
      "href": "/#/pkg/btoc?keyword=锂电池"
    }
  }, [_vm._v("EMBA教育")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/pkg/btoc?keyword=智能电表"
    }
  }, [_vm._v("保险")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/pkg/btoc?keyword=汽车"
    }
  }, [_vm._v("大健康")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/pkg/btoc?keyword=智能手表"
    }
  }, [_vm._v("金融理财")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/pkg/btoc?keyword=环保材料"
    }
  }, [_vm._v("投资移民")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/pkg/btoc?keyword=电子设备"
    }
  }, [_vm._v("医疗美容 ...")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "easy-use-register"
  }, [_c('ul', {
    staticClass: "search-nav clearfix"
  }, [_c('li', {
    staticClass: "search-type active",
    attrs: {
      "data": "result"
    }
  }, [_vm._v("\n                    查企业\n                  ")]), _vm._v(" "), _c('li', {
    staticClass: "search-type",
    attrs: {
      "data": "hum"
    }
  }, [_vm._v("\n                    搜老板\n                  ")]), _vm._v(" "), _c('li', {
    staticClass: "search-type",
    attrs: {
      "data": "map"
    }
  }, [_vm._v("\n                    位置获客\n                  ")]), _vm._v(" "), _c('li', {
    staticClass: "search-type",
    attrs: {
      "data": "package"
    }
  }, [_vm._v("\n                    数据集市\n                  ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "easy-use-register"
  }, [_c('input', {
    staticClass: "easy-use-phone",
    attrs: {
      "id": "txt_input",
      "placeholder": "请输入企业名称、品牌名称、核心人员姓名等关键词。"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn_yellow",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("搜一下")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "easy-use-register"
  }, [_c('div', {
    staticClass: "quick_panel",
    attrs: {
      "data": "result"
    }
  }, [_c('div', {
    staticClass: "quick_left"
  }, [_c('div', [_vm._v("热门")]), _vm._v(" "), _c('div', [_vm._v("搜索")])]), _vm._v(" "), _c('div', {
    staticClass: "quick_right"
  }, [_c('div', {
    staticClass: "quick_link"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=高新企业"
    }
  }, [_vm._v("高新企业")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/result?tags=专精特新企业"
    }
  }, [_vm._v("专精特新企业")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/result?tags=专精特新小巨人企业"
    }
  }, [_vm._v("小巨人企业")]), _vm._v(" "), _c('a', {
    staticClass: "pc-show",
    attrs: {
      "href": "/#/result?tags=A股"
    }
  }, [_vm._v("上市公司")]), _vm._v(" "), _c('a', {
    staticClass: "pc-show",
    attrs: {
      "href": "/#/result?tags=瞪羚企业"
    }
  }, [_vm._v("瞪羚企业")]), _vm._v(" "), _c('a', {
    staticClass: "pc-show",
    attrs: {
      "href": "/#/result?tags=独角兽企业"
    }
  }, [_vm._v("独角兽企业")]), _vm._v(" "), _c('a', {
    staticClass: "pc-show",
    attrs: {
      "href": "/#/result?tags=央企"
    }
  }, [_vm._v("央企")])]), _vm._v(" "), _c('div', {
    staticClass: "quick_link"
  }, [_c('a', {
    attrs: {
      "href": "/#/result?tags=中概股"
    }
  }, [_vm._v("海外上市公司")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/result?keyword=极米光电"
    }
  }, [_vm._v("极米光电")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/result?keyword=小爱科技"
    }
  }, [_vm._v("小爱科技")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/result?keyword=华谊兄弟"
    }
  }, [_vm._v("华谊兄弟")]), _vm._v(" "), _c('a', {
    staticClass: "pc-show",
    attrs: {
      "href": "/#/result?keyword=鸿星尔克"
    }
  }, [_vm._v("鸿星尔克")]), _vm._v(" "), _c('a', {
    staticClass: "pc-show",
    attrs: {
      "href": "/#/result?keyword=天能电池"
    }
  }, [_vm._v("天能电池")]), _vm._v(" "), _c('a', {
    staticClass: "pc-show",
    attrs: {
      "href": "/#/result?keyword=通联支付"
    }
  }, [_vm._v("通联支付")])])])]), _vm._v(" "), _c('div', {
    staticClass: "quick_panel hidden",
    attrs: {
      "data": "package"
    }
  }, [_c('a', {
    staticClass: "quick_left",
    attrs: {
      "href": "/#/package"
    }
  }, [_c('div', [_vm._v("数据")]), _vm._v(" "), _c('div', [_vm._v("集市")])]), _vm._v(" "), _c('div', {
    staticClass: "quick_right"
  }, [_c('div', {
    staticClass: "quick_link"
  }, [_c('a', {
    attrs: {
      "href": "/#/pkg/btob?keyword=B2B领域"
    }
  }, [_vm._v("B2B领域：")]), _vm._v(" "), _c('a', {
    staticClass: "pl-0",
    attrs: {
      "href": "/#/pkg/btob?keyword=产业招商"
    }
  }, [_vm._v("产业招商")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/pkg/btob?keyword=企业金融"
    }
  }, [_vm._v("企业金融")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/pkg/btob?keyword=展会"
    }
  }, [_vm._v("展会")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/pkg/btob?keyword=咨询服务"
    }
  }, [_vm._v("咨询服务")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/pkg/btob?keyword=知识产权服务"
    }
  }, [_vm._v("知识产权服务 ...\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "quick_link"
  }, [_c('a', {
    attrs: {
      "href": "/#/ipr?keyword=B2C领域"
    }
  }, [_vm._v("B2C领域：")]), _vm._v(" "), _c('a', {
    staticClass: "pl-0",
    attrs: {
      "href": "/#/pkg/btoc?keyword=EMBA教育"
    }
  }, [_vm._v("EMBA教育")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/pkg/btoc?keyword=投资移民"
    }
  }, [_vm._v("投资移民")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/pkg/btoc?keyword=保险"
    }
  }, [_vm._v("保险")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/pkg/btoc?keyword=金融理财"
    }
  }, [_vm._v("金融理财")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/pkg/btoc?keyword=医疗美容"
    }
  }, [_vm._v("医疗美容")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/pkg/btoc?keyword=大健康"
    }
  }, [_vm._v("大健康 ...")])])])]), _vm._v(" "), _c('div', {
    staticClass: "quick_panel hidden",
    attrs: {
      "data": "hum"
    }
  }, [_c('div', {
    staticClass: "quick_left"
  }, [_c('div', [_vm._v("热门")]), _vm._v(" "), _c('div', [_vm._v("搜索")])]), _vm._v(" "), _c('div', {
    staticClass: "quick_right"
  }, [_c('div', {
    staticClass: "quick_link"
  }, [_c('a', {
    attrs: {
      "href": "/#/boss?keyword=张勇"
    }
  }, [_vm._v("张勇")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/boss?keyword=赵伟国"
    }
  }, [_vm._v("赵伟国")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/boss?keyword=罗平"
    }
  }, [_vm._v("罗平")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/boss?keyword=柳晓红"
    }
  }, [_vm._v("柳晓红")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/boss?keyword=孙小波"
    }
  }, [_vm._v("孙小波")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/boss?keyword=胡兵"
    }
  }, [_vm._v("胡兵")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/boss?keyword=刘宗双"
    }
  }, [_vm._v("刘宗双")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/boss?keyword=胡溢"
    }
  }, [_vm._v("胡溢")])]), _vm._v(" "), _c('div', {
    staticClass: "quick_link"
  }, [_c('a', {
    attrs: {
      "href": "/#/boss?keyword=王永川"
    }
  }, [_vm._v("王永川")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/boss?keyword=李俊毅"
    }
  }, [_vm._v("李俊毅")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/boss?keyword=廖浦伽"
    }
  }, [_vm._v("廖浦伽")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/boss?keyword=黄乐炜"
    }
  }, [_vm._v("黄乐炜")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/boss?keyword=任登万"
    }
  }, [_vm._v("任登万")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/boss?keyword=宋伟春"
    }
  }, [_vm._v("宋伟春")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/boss?keyword=杨琳"
    }
  }, [_vm._v("杨琳")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/boss?keyword=李海清"
    }
  }, [_vm._v("李海清")])])])]), _vm._v(" "), _c('div', {
    staticClass: "quick_panel hidden",
    attrs: {
      "data": "chain"
    }
  }, [_c('div', {
    staticClass: "quick_left"
  }, [_c('div', [_vm._v("热门")]), _vm._v(" "), _c('div', [_vm._v("搜索")])]), _vm._v(" "), _c('div', {
    staticClass: "quick_right"
  }, [_c('div', {
    staticClass: "quick_link"
  }, [_c('a', {
    attrs: {
      "href": "/#/chain?keyword=SMC"
    }
  }, [_vm._v("SMC")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/chain?keyword=极米光电"
    }
  }, [_vm._v("极米光电")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/chain?keyword=小爱科技"
    }
  }, [_vm._v("小爱科技")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/chain?keyword=华谊兄弟"
    }
  }, [_vm._v("华谊兄弟")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/chain?keyword=鸿星尔克"
    }
  }, [_vm._v("鸿星尔克")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/chain?keyword=天能电池"
    }
  }, [_vm._v("天能电池")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/chain?keyword=通联支付"
    }
  }, [_vm._v("通联支付")])]), _vm._v(" "), _c('div', {
    staticClass: "quick_link"
  }, [_c('a', {
    attrs: {
      "href": "/#/chain?keyword=贾跃亭"
    }
  }, [_vm._v("贾跃亭")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/chain?keyword=李易峰"
    }
  }, [_vm._v("李易峰")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/chain?keyword=恒大集团"
    }
  }, [_vm._v("恒大集团")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/chain?keyword=杨建忠"
    }
  }, [_vm._v("杨建忠")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/chain?keyword=邹维康"
    }
  }, [_vm._v("邹维康")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/chain?keyword=马浩宁"
    }
  }, [_vm._v("马浩宁")])])])]), _vm._v(" "), _c('div', {
    staticClass: "quick_panel hidden",
    attrs: {
      "data": "map"
    }
  }, [_c('div', {
    staticClass: "quick_left"
  }, [_c('div', [_vm._v("地图")]), _vm._v(" "), _c('div', [_vm._v("搜索")])]), _vm._v(" "), _c('div', {
    staticClass: "quick_right"
  }, [_c('div', {
    staticClass: "quick_link"
  }, [_c('a', {
    attrs: {
      "href": "/#/bid?keyword=大数据"
    }
  }, [_vm._v("大数据")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/bid?keyword=防洪"
    }
  }, [_vm._v("防洪")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/bid?keyword=钢材"
    }
  }, [_vm._v("钢材")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/bid?keyword=公路桥梁"
    }
  }, [_vm._v("公路桥梁")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/bid?keyword=装修"
    }
  }, [_vm._v("装修")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/bid?keyword=仪表"
    }
  }, [_vm._v("仪表")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/bid?keyword=市政改造"
    }
  }, [_vm._v("市政改造")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/bid?keyword=计量"
    }
  }, [_vm._v("计量")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/bid?keyword=金融科技"
    }
  }, [_vm._v("金融科技")])]), _vm._v(" "), _c('div', {
    staticClass: "quick_link"
  }, [_c('a', {
    attrs: {
      "href": "/#/bid?keyword=供电设备"
    }
  }, [_vm._v("供电设备")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/bid?keyword=大学"
    }
  }, [_vm._v("大学")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/bid?keyword=体育设施"
    }
  }, [_vm._v("体育设施")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/bid?keyword=工程装修"
    }
  }, [_vm._v("工程装修")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/bid?keyword=图书馆"
    }
  }, [_vm._v("图书馆")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/bid?keyword=汽车"
    }
  }, [_vm._v("汽车")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/bid?keyword=新能源"
    }
  }, [_vm._v("新能源")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/#/bid?keyword=环保"
    }
  }, [_vm._v("环保")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navList-img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/app-1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navList-text"
  }, [_c('div', {
    staticClass: "navList-text-title"
  }, [_vm._v("批量查询")]), _vm._v(" "), _c('div', {
    staticClass: "navList-text-desc"
  }, [_vm._v("用户批量上传数据，一键导出")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navList-img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/app-5.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navList-text"
  }, [_c('div', {
    staticClass: "navList-text-title"
  }, [_vm._v("报告&导出")]), _vm._v(" "), _c('div', {
    staticClass: "navList-text-desc"
  }, [_vm._v("用户导出的数据列表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navList-img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/app-9.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navList-text"
  }, [_c('div', {
    staticClass: "navList-text-title"
  }, [_vm._v("广告投放")]), _vm._v(" "), _c('div', {
    staticClass: "navList-text-desc"
  }, [_vm._v("提供精准人群包定向投放广告")]), _vm._v(" "), _c('img', {
    staticClass: "app-icon-new",
    attrs: {
      "src": "/static/img/app-new.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navList-img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/app-6.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navList-text"
  }, [_c('div', {
    staticClass: "navList-text-title"
  }, [_vm._v("渠道合作")]), _vm._v(" "), _c('div', {
    staticClass: "navList-text-desc"
  }, [_vm._v("欢迎更多友商合作加盟")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-scenarios-title"
  }, [_c('span', {
    staticClass: "d-block"
  }, [_vm._v("从获客到营销")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "scene-title d-block"
  }, [_vm._v("1\n                    "), _vm._v(".\n                    "), _vm._v("全量企业、产业链精准获客\n\t\t\t\t\t\t\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "scene-title d-block"
  }, [_vm._v("2\n                    "), _vm._v(".\n                    "), _vm._v("地理位置获客找附近的公司和老板\n\t\t\t\t\t\t\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scene-body scene-body-hidden"
  }, [_c('div', {
    staticClass: "scene-desc"
  }, [_c('p', [_vm._v("\n                        在地图页面点选位置，系统会根据经纬度找出指定范围之内的企业或企业高管，可导出数据，也可根据企业规模、所在行业做进一步筛选导出。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "scene-title d-block"
  }, [_vm._v("3\n                    "), _vm._v(".\n                    "), _vm._v("数据集市和数据导出\n\t\t\t\t\t\t\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "scene-title d-block"
  }, [_vm._v("4\n                    "), _vm._v(".\n                    "), _vm._v("用户自有数据分析平台\n\t\t\t\t\t\t\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scene-body scene-body-hidden"
  }, [_c('div', {
    staticClass: "scene-desc"
  }, [_c('p', [_vm._v("\n                        支持用户将自有数据或指定企业名单上传，系统会自动分析用户所上传的数据，提供信用评分和风险信息，提供属性和标签补全服务。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "scene-title d-block"
  }, [_vm._v("5\n                    "), _vm._v(".\n                    "), _vm._v("数字营销和智能广告投放\n\t\t\t\t\t\t\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scene-body scene-body-hidden"
  }, [_c('div', {
    staticClass: "scene-desc"
  }, [_c('p', [_vm._v("提供千人千面的产品展现能力，融合算法和业务规则，实现精准营销和推荐。")]), _vm._v(" "), _c('p', [_vm._v("与主流数字广告平台对接，提供精准人群包，可实现定向人群精准广告投放，大幅提升广告转化率。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "scene-title d-block"
  }, [_vm._v("6\n                    "), _vm._v(".\n                    "), _vm._v("风险预警和反欺诈\n\t\t\t\t\t\t\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scene-body scene-body-hidden"
  }, [_c('div', {
    staticClass: "scene-desc"
  }, [_c('p', [_vm._v("\n                        可提供交易欺诈识别、黑产防范、消费信贷和信贷风险评估、预防保险欺诈。企业和相关人员失信信息、处罚信息查询和及时预警。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "module-shopping clearfix pc-hidden"
  }, [_c('div', {
    staticClass: "wrapper-with-shadow"
  }, [_c('div', {
    staticClass: "section-title-box"
  }, [_c('span', {
    staticClass: "title-pc"
  }, [_vm._v("多个行业成功案例")]), _vm._v(" "), _c('div', {
    staticClass: "title-mobile"
  }, [_c('span', {
    staticClass: "d-block text-center"
  }, [_vm._v("多个行业成熟")]), _c('span', {
    staticClass: "d-block text-center"
  }, [_vm._v("应用案例")])])]), _vm._v(" "), _c('p', {
    staticClass: "section-des"
  }, [_vm._v("行业数据集，开箱即用")]), _vm._v(" "), _c('div', {
    staticClass: "module-shopping-content"
  }, [_c('div', {
    staticClass: "swiper mySwiper"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    attrs: {
      "href": "",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "module-img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/swipper/qiye.png"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("企业服务")])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    attrs: {
      "href": "",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "module-img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/swipper/zhanghui.png"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("产业招商")])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    attrs: {
      "href": "",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "module-img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/swipper/jinrong.png"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("金融服务")])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    attrs: {
      "href": "",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "module-img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/swipper/peixung.png"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("教育培训")])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    attrs: {
      "href": "",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "module-img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/swipper/zhanghui.png"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("会展")])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    attrs: {
      "href": "",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "module-img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/swipper/baoxian.png"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("保险获客")])])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })]), _vm._v(" "), _c('div', {
    staticClass: "module-shopping-btn"
  }, [_c('a', {
    staticClass: "btn btn-outline module-shopping-more",
    attrs: {
      "href": "/#/package",
      "target": "_self"
    }
  }, [_vm._v("更多体验")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "empower-career clearfix",
    staticStyle: {
      "background-color": "#efefef"
    }
  }, [_c('div', [_c('div', {
    staticClass: "corporate-reputation"
  }, [_c('div', {
    staticClass: "title-pc"
  }, [_vm._v("企业大数据信赖之选")]), _vm._v(" "), _c('div', {
    staticClass: "title-mobile"
  }, [_c('span', {
    staticClass: "d-block text-center"
  }, [_vm._v("企业大数据")]), _c('span', {
    staticClass: "d-block text-center"
  }, [_vm._v("信赖之选")])]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "reputations-container"
  }, [_c('div', {
    staticClass: "reputation-item"
  }, [_c('div', {
    staticClass: "item-count"
  }, [_vm._v("3.3亿+")]), _vm._v(" "), _c('div', {
    staticClass: "item-name"
  }, [_vm._v("工商实体")])]), _vm._v(" "), _c('div', {
    staticClass: "reputation-item"
  }, [_c('div', {
    staticClass: "item-count"
  }, [_vm._v("5.4亿+")]), _vm._v(" "), _c('div', {
    staticClass: "item-name"
  }, [_vm._v("法人&高管")])]), _vm._v(" "), _c('div', {
    staticClass: "reputation-item"
  }, [_c('div', {
    staticClass: "item-count"
  }, [_vm._v("1.4亿+")]), _vm._v(" "), _c('div', {
    staticClass: "item-name"
  }, [_vm._v("裁判文书")])]), _vm._v(" "), _c('div', {
    staticClass: "reputation-item"
  }, [_c('div', {
    staticClass: "item-count"
  }, [_vm._v("4千万+")]), _vm._v(" "), _c('div', {
    staticClass: "item-name"
  }, [_vm._v("专利数据库")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9fba1ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Default.vue
// module id = 292
// module chunks = 1